
import React, { useState, useEffect } from 'react';
import { useProductForm } from './hooks/useProductForm';
import { useToast } from '@/components/ui/use-toast';
import { supabase } from '@/lib/supabase';
import ProductHeaderActions from './components/ProductHeaderActions';
import DeleteProductDialog from './components/DeleteProductDialog';
import ProductFormLoading from './components/ProductFormLoading';
import ProductFormWrapper from './components/ProductFormWrapper';
import { useOrganizationId } from './hooks/useOrganizationId';

interface ProductEditFormProps {
  productId: string;
  onBack: () => void;
  onSuccess: () => void;
  shopId?: string;
}

const ProductEditForm = ({ productId, onBack, onSuccess, shopId }: ProductEditFormProps) => {
  const isNew = productId === 'new';
  const { toast } = useToast();
  const [confirmDelete, setConfirmDelete] = useState(false);
  const { organizationId, loading: orgLoading } = useOrganizationId();
  
  console.log('ProductEditForm avec shopId:', shopId);
  console.log('ProductEditForm avec organizationId:', organizationId);
  
  useEffect(() => {
    if (isNew && !organizationId) {
      console.error("Pas d'ID d'organisation disponible pour créer un produit");
      toast({
        title: "Erreur",
        description: "Impossible de créer un produit sans organisation",
        variant: "destructive"
      });
    }
  }, [isNew, organizationId, toast]);
  
  const productForm = useProductForm({
    productId,
    isNewProduct: isNew,
    onBack,
    onSuccess,
    shopId,
    organizationId
  });
  
  const handleDelete = async () => {
    try {
      const { error } = await supabase
        .from('products')
        .delete()
        .eq('id', productId);
      
      if (error) throw error;
      
      toast({
        title: "Produit supprimé",
        description: "Le produit a été supprimé avec succès."
      });
      onSuccess();
    } catch (error) {
      console.error("Erreur lors de la suppression du produit:", error);
      toast({
        title: "Erreur",
        description: "Une erreur est survenue lors de la suppression du produit.",
        variant: "destructive"
      });
    }
  };
  
  if ((orgLoading && isNew) || productForm.loading) {
    return <ProductFormLoading />;
  }
  
  return (
    <div className="space-y-6">
      <div className="container mx-auto px-4 py-6 space-y-8">
        <ProductHeaderActions
          onBack={onBack}
          onSave={productForm.handleSave}
          onDelete={isNew ? undefined : () => setConfirmDelete(true)}
          saving={productForm.saving}
          isNew={isNew}
          product={productForm.product}
        />
        
        <ProductFormWrapper 
          productForm={productForm}
          shopId={shopId || productForm.product?.shop_id}
          organizationId={organizationId}
          defaultFormId={productForm.defaultFormId}
        />
      </div>
      
      <DeleteProductDialog 
        open={confirmDelete}
        onOpenChange={setConfirmDelete}
        onDelete={handleDelete}
      />
    </div>
  );
};

export default ProductEditForm;
